export function parseMultiFilterValue(value) {
  const normalized = String(value || '').trim();
  if (!normalized) return [];
  try {
    const parsed = JSON.parse(normalized);
    if (Array.isArray(parsed)) {
      return parsed.map(item => String(item).trim()).filter(Boolean);
    }
  } catch (_error) {
    // Compatibilidad con enlaces que almacenaban un único valor.
  }
  return [normalized];
}

export function serializeMultiFilterValue(values) {
  return Array.isArray(values) && values.length > 0 ? JSON.stringify(values) : '';
}

export function normalizeMultiSelection(values, allValue = '__all__') {
  return (Array.isArray(values) ? values : [])
    .map(value => String(value ?? '').trim())
    .filter(value => value && value !== allValue);
}

export function getMultiFilterLabel(options, selectedValues) {
  return normalizeMultiSelection(selectedValues)
    .map(value => options.find(option => String(option?.id) === value)?.name || '')
    .filter(Boolean)
    .join(', ');
}

export function matchesAnySelected(selectedValues, candidate, normalize = String) {
  if (!Array.isArray(selectedValues) || selectedValues.length === 0) return true;
  const normalizedCandidate = normalize(candidate);
  return selectedValues.some(value => normalize(value) === normalizedCandidate);
}
